// removed by extract-text-webpack-plugin
module.exports = {"courseHeader":"_3jQjmH22uBl5j_vmAR2j9I","container":"_3-VvrAQrxr9GYDDqaPzzyA","courseIcon":"_2e4pi0hMbeff1kgOLhJehK","tabs":"_7NWxFZ3R1oAh4JBQXwLur","courseTitle":"_2UQXyrlIjEg7OLNWR_6Rvi","courseBody":"_3O_YDwMpuAay2Ss6CjH76_"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Course/CoursePage.css
// module id = 1196
// module chunks = 0